import { action, extendObservable } from 'mobx';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import { apiCall } from '../API';
import AsyncActionStore from './AsyncActionStore';
import InputStore from './InputStore';

export default class RegOptionsStore {
    static PropType = PropTypes.shape({
        loadStatus: AsyncActionStore.PropType.isRequired,
        useSsoLogin: PropTypes.bool.isRequired,
        useAccessCodes: PropTypes.bool.isRequired,
        emailDisabled: PropTypes.bool.isRequired,
        primaryDomain: PropTypes.string.isRequired,
        emailDomains: MobxPropTypes.arrayOrObservableArrayOf(PropTypes.string.isRequired).isRequired,
        ipRanges: MobxPropTypes.arrayOrObservableArrayOf(PropTypes.string.isRequired).isRequired,
        domainSearch: InputStore.PropType.isRequired,
        ipRangesSearch: InputStore.PropType.isRequired,
        hashEmail: PropTypes.bool.isRequired,
        setEmailReg: PropTypes.func.isRequired,
        setIpReg: PropTypes.func.isRequired,
        load: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class RegOptionsStore */ {
            apiLoad: apiCall('/console/registration_options/', { isUserAction: false }),
            loadStatus: new AsyncActionStore(),
            domainSearch: new InputStore(),
            ipRangesSearch: new InputStore(),
            useSsoLogin: false,
            useAccessCodes: false,
            emailDisabled: false,
            primaryDomain: '',
            emailDomains: [],
            ipRanges: [],
            hashEmail: true,

            get filteredDomains() {
                const emailDomains = !this.emailDomains ? [] : this.emailDomains.sort((domain1, domain2) => {
                    if (domain1 === this.primaryDomain) {
                        return -1;
                    }
                    if (domain2 === this.primaryDomain) {
                        return 1;
                    }
                    return 0;
                });
                const query = this.domainSearch.value.trim().toLowerCase();
                if (!query) {
                    return emailDomains;
                }
                return emailDomains.filter((domain) => domain.toLowerCase().includes(query));
            },

            get filteredIpRanges() {
                const query = this.ipRangesSearch.value.trim().toLowerCase();
                if (!query) {
                    return this.ipRanges;
                }
                return this.ipRanges.filter((ipRangesItem) => ipRangesItem.toLowerCase().includes(query));
            },
        }, data);
    }

    setEmailReg = action((data) => {
        this.useSsoLogin = data.useSsoLogin;
        this.useAccessCodes = data.useAccessCodes;
        this.emailDisabled = data.emailDisabled;
        this.emailDomains.replace(data.emailDomains);
    });

    setIpReg = action((data) => {
        this.ipRanges.replace(data.ipRanges);
    });

    load = action(() => {
        if (!this.loadStatus.isLoading) {
            this.loadStatus.setLoading(this.apiLoad())
                .then(action((res) => {
                    this.setEmailReg(res);
                    this.setIpReg(res);
                    this.hashEmail = res.hashEmail;
                    this.primaryDomain = this.getPrimaryDomain(res);
                    return res;
                }));
        }
        return this.loadStatus.promise;
    });

    getPrimaryDomain = (data) => {
        const primaryUserDomain = data.primaryUserEmail && data.primaryUserEmail.split('@')[1];
        return primaryUserDomain && data.emailDomains &&
            data.emailDomains.find((domain) => primaryUserDomain.includes(domain));
    };
}
